module.exports = __webpack_public_path__ + "static/media/close.ae0ddd64.png";